import React from "react";
import ChartBase from "./ChartBase";

const AreaCharts = ({
  series = [],
  categories = [],
  options = {},
  height = "100%",
  width = "100%",
}) => {
  const baseOptions = {
    chart: {},
    stroke: { curve: "smooth", width: 2 },
    dataLabels: { enabled: false },
    xaxis: { categories },
    markers: { size: 0 },
    fill: { type: "gradient", opacity: 0.2 },
  };

  const mergedOptions = {
    ...baseOptions,
    ...options,
    xaxis: { ...baseOptions.xaxis, ...(options.xaxis || {}), categories },
    fill: { ...baseOptions.fill, ...(options.fill || {}) },
  };

  return (
    <ChartBase
      type="area"
      series={series}
      categories={categories}
      options={mergedOptions}
      height={height}
      width={width}
    />
  );
};

export default AreaCharts;
